import {
  countriesOption,
} from '@noitada/shared/arrays/App/countries.array';

import {
  Mask,
} from '../components/Composh/plugins';

import {
  TextInputMaskTypeProp,
} from '../components/Composh/plugins/Mask/input.types';



export function FormatSymbolMoney(country = 'BRA'): string {
  if (!country) {
    return '';
  }

  const findSymbolMoney = countriesOption?.find((item) => item.code === country);
  return findSymbolMoney?.moneySymbol;
};



export function FormatMoney(value: string | number | null | undefined, showUnit = true, country = 'BRA'): string {
  const findSymbolMoney = countriesOption?.find((item) => item.code === country);


  if (!value || value === '' || value === null || value === undefined) {
    return Mask.toMask('money', '000', {
      precision: 2,
      separator: ',',
      delimiter: '.',
      unit: showUnit ? `${findSymbolMoney?.moneySymbol} ` : '',
      suffixUnit: '',
    });
  }

  if (typeof value === 'number') {
    value = Math.floor(value);
  }

  return Mask.toMask('money', String(value), {
    precision: 2,
    separator: ',',
    delimiter: '.',
    unit: showUnit ? `${findSymbolMoney?.moneySymbol} ` : '',
    suffixUnit: '',
  });
};



export function FormatPhone(number: string, type = 'BRL'): string {
  if (!number || !type) {
    return '';
  }

  if (number.length <= 5) {
    return number;
  }

  if (number.startsWith('0800') && number.length > 5) {
    const formattedNumber = `0800-${number.substring(4)}`;
    return formattedNumber;
  }

  const phoneMasked = Mask.toMask('phone', number, {
    maskType: 'BRL',
    withDDD: true,
    dddMask: '(99) ',
  });

  return phoneMasked;
};



export function GetMaskRawValue(mask: string, value: string | number | null | undefined): string {
  if (!value || value === '' || value === null || value === undefined) {
    return '';
  }

  if (!mask || mask === null || mask === undefined) {
    return '';
  }

  const MaskLowCase = mask.toLowerCase() as TextInputMaskTypeProp;

  return Mask.toRawValue(MaskLowCase, String(value));
};
